export const ErrorStateNotFoundIllustration = () => {
  return (
    <svg viewBox="0 0 175 175" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.1521 45.2715C24.7904 45.2715 22.0652 47.9967 22.0652 51.3585V121.358C22.0652 124.72 24.7904 127.445 28.1521 127.445H63.8386L84.0779 93.1059C86.9887 88.1673 94.0982 88.1673 97.009 93.1059L117.248 127.445H146.848C150.21 127.445 152.935 124.72 152.935 121.358V51.3584C152.935 47.9967 150.21 45.2715 146.848 45.2715H28.1521Z"
        fill="#F6B2B2"
      />
      <path
        d="M88.2466 95.2829C89.286 93.5287 91.8248 93.5287 92.8642 95.2829L122.145 144.698C123.205 146.487 121.916 148.75 119.836 148.75H61.2747C59.1953 148.75 57.9059 146.487 58.9659 144.698L88.2466 95.2829Z"
        fill="#DC4C4C"
      />
      <path
        d="M90.1631 133.806C89.5887 133.806 89.184 133.611 88.949 133.222C88.7402 132.832 88.6227 132.373 88.5966 131.845L87.8525 112.398C87.8264 111.48 87.9569 110.715 88.2441 110.103C88.5574 109.491 89.1971 109.185 90.1631 109.185C90.9985 109.185 91.586 109.449 91.9254 109.977C92.2648 110.478 92.4345 111.146 92.4345 111.981V112.398L91.6904 131.845C91.6643 132.373 91.5468 132.832 91.3379 133.222C91.1291 133.611 90.7375 133.806 90.1631 133.806ZM90.163 142.663C88.3877 142.663 87.5 141.703 87.5 139.783C87.5 138.977 87.7611 138.309 88.2832 137.78C88.8315 137.252 89.4712 136.987 90.2022 136.987C90.9071 136.987 91.5207 137.279 92.0428 137.864C92.565 138.42 92.8261 139.074 92.8261 139.825C92.8261 141.717 91.9384 142.663 90.163 142.663Z"
        fill="white"
      />
      <path
        d="M22.0652 51.3589C22.0652 47.9972 24.7904 45.272 28.1521 45.272H146.848C150.21 45.272 152.935 47.9972 152.935 51.3589V58.9676H22.0652V51.3589Z"
        fill="#DC4C4C"
      />
      <rect
        x="33.4783"
        y="77.228"
        width="106.522"
        height="4.56522"
        rx="2.28261"
        fill="white"
      />
      <rect
        x="33.4783"
        y="87.8804"
        width="33.4783"
        height="4.56522"
        rx="2.28261"
        fill="white"
      />
      <rect
        x="33.4783"
        y="67.3369"
        width="33.4783"
        height="4.56522"
        rx="2.28261"
        fill="white"
      />
      <path
        d="M141.704 39.8772C139.249 41.0114 136.34 39.9413 135.206 37.4869C134.072 35.0326 135.142 32.1235 137.596 30.9893C140.051 29.855 142.96 30.9252 144.094 33.3795C145.228 35.8338 144.158 38.7429 141.704 39.8772Z"
        fill="#DC4C4C"
      />
      <path
        d="M43.2751 131.732C45.6299 130.403 48.6159 131.235 49.9445 133.59C51.2731 135.945 50.4412 138.931 48.0865 140.259C45.7317 141.588 42.7457 140.756 41.4171 138.401C40.0885 136.047 40.9203 133.061 43.2751 131.732Z"
        fill="#F6B2B2"
      />
      <path
        d="M149.748 31.7208C148.521 32.2879 147.067 31.7529 146.499 30.5257C145.932 29.2985 146.467 27.844 147.695 27.2769C148.922 26.7097 150.376 27.2448 150.943 28.472C151.51 29.6991 150.975 31.1537 149.748 31.7208Z"
        fill="#DC4C4C"
      />
      <path
        d="M35.9149 140.511C37.0923 139.846 38.5853 140.262 39.2496 141.44C39.9139 142.617 39.498 144.11 38.3206 144.774C37.1432 145.439 35.6502 145.023 34.9859 143.845C34.3216 142.668 34.7375 141.175 35.9149 140.511Z"
        fill="#F6B2B2"
      />
    </svg>
  );
};
